export default __webpack_public_path__ + "static/media/btn-delete-bg.48317119.svg";